import api from "@/utils/http";

/**
 功能：
 time: 2025/12/26 18:17
 **/
export function getExpendConfig() {
    return api.get('/admin/expend/getSetConfig')
}

/**
 功能：
 time: 2026/1/6 13:43
 **/
export function getExpendList(data) {
    return api.post('/partner/expend/getList', data)
}

/**
 功能：
 time: 2026/3/9 16:28
 **/
export function getExpendStatic(data) {
    return api.post('/partner/expend/getStaticData', data)
}

/**
 功能：查看指定客户账单
 time: 2025/12/16 11:02
 **/
export function getCompanyBillList(company_id) {
    return api.post('/admin/expend/getCompanyBillList', { company_id})
}

/**
 功能：
 time: 2025/12/27 09:59
 **/
export function saveExpend(data) {
    return api.post('/admin/expend/eSave', data)
}

/**
 功能：
 time: 2026/1/6 14:59
 **/
export function onSaveExpend(data) {
    return api.post('/admin/expend/oSave', data)
}

/**
 功能：
 time: 2025/12/27 11:01
 **/
export function examineExpend(data) {
    return api.post('/admin/expend/examineSave', data)
}

/**
 功能：
 time: 2025/12/27 11:47
 **/
export function payExpend(data) {
    return api.post('/admin/expend/paySave', data)
}

/**
 功能：
 time: 2025/12/27 10:26
 **/
export function getExpendDetail(expend_id) {
    return api.post('/partner/expend/getDetail', { expend_id })
}

/**
 功能：
 time: 2025/12/27 10:33
 **/
export function deleteExpend(expend_id) {
    return api.post('/admin/expend/del', {expend_id})
}

